import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-aesthetic-individuality-report',
  templateUrl: './aesthetic-individuality-report.component.html',
  styleUrls: ['./aesthetic-individuality-report.component.scss']
})
export class AestheticIndividualityReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
